/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: mojmir.studenovsky@eurowag.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UnitCodeWeight,
    UnitCodeWeightFromJSON,
    UnitCodeWeightFromJSONTyped,
    UnitCodeWeightToJSON,
} from './';

/**
 * 
 * @export
 * @interface Weight
 */
export interface Weight {
    /**
     * 
     * @type {number}
     * @memberof Weight
     */
    value: number;
    /**
     * 
     * @type {UnitCodeWeight}
     * @memberof Weight
     */
    unit: UnitCodeWeight;
}

export function WeightFromJSON(json: any): Weight {
    return WeightFromJSONTyped(json, false);
}

export function WeightFromJSONTyped(json: any, ignoreDiscriminator: boolean): Weight {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'unit': UnitCodeWeightFromJSON(json['unit']),
    };
}

export function WeightToJSON(value?: Weight | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'unit': UnitCodeWeightToJSON(value.unit),
    };
}


